import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';

@Directive({
    selector: '[appBannerObserver]',
    standalone: false
})
export class BannerObserverDirective implements AfterViewInit, OnDestroy {
  @Output() bannerVisible = new EventEmitter<void>();
  private observer: IntersectionObserver

  constructor(private el: ElementRef) { }
  
  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        for (let entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            this.bannerVisible.emit();
            this.observer.disconnect();
          }
        }
      },
      { threshold: 0.5 }
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }
}
